import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { DefaultText, Icon, FlexWrapper } from './'

const Overlay = styled.div`
  position: fixed;
  display: block;
  min-width: 100%;
  height: 100%;
  top: ${props => (props.top ? props.top : '0px')};
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999999;
  cursor: pointer;
  max-width: 768px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
`
/* const zoomIn = keyframes`
  from {
    opacity: 0;
    -webkit-transform: scale3d(.3, .3, .3);
    transform: scale3d(.3, .3, .3);
  }
  90% {
    opacity: 1;
  }
`
const zoomOut = keyframes`
from {
  opacity: 1;
}

50% {
  opacity: 0;
  -webkit-transform: scale3d(0.3, 0.3, 0.3);
  transform: scale3d(0.3, 0.3, 0.3);
}

to {
  opacity: 0;
}
` */
const fadeInUp = keyframes`
from {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

to {
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
`
/* const fadeInDown = keyframes`
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}
` */

/* const zoomInanimation = props =>
  css`
    ${zoomIn} ${props.animationLength}  linear;
  `

const zoomOutAnimation = props =>
  css`
    ${zoomOut} ${props.animationLength}  linear;
  ` */
const Div = styled.div`
  padding: 2px 6px;
`
const ModalWrapper = styled.div`
  animation: ${fadeInUp} 0.2s linear;
  width: 100%;
  padding: ${props => (props.padding ? props.padding : '0 0 20px 0')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '340px')};
  border-radius: 2px;
  background-color: #f5f5f5;
  // box-shadow: 0 1px 3px 2px rgba(204, 204, 204, 0.5);
  display: ${props => (props.show ? 'block' : 'none')};
  margin: 0 auto;
  border-radius: 5px 5px 0 0;
  max-height: ${props => (props.maxHeight ? props.maxHeight : '400px')};
  overflow-y: auto;
  ${props =>
    props.list &&
    `
  position: fixed;
  bottom: 59px;
  left: calc(50% - 170px);
  padding: 0px;
  `};
`
class Modal extends Component {
  state = {}
  render() {
    const { show, hide, maxWidth, children, title, onClose, list, viewPadding, top, ...props } = this.props
    return (
      <React.Fragment>
        {show && (
          <Overlay top={top}>
            <ModalWrapper maxWidth={maxWidth} show={show} hide={hide} list={list} {...props}>
              <FlexWrapper
                direction="row"
                viewPadding={'11px 16px'}
                alignItems="center"
                justifyContent="space-between"
                backgroundColor="#fff"
                borderRadius="5px 5px 0 0"
                border="0.5px solid #dcdcdc">
                <DefaultText color="#124b5f">{title}</DefaultText>
                {onClose && (
                  <Div onClick={() => (onClose ? onClose() : null)}>
                    <Icon icon="closeModal" />
                  </Div>
                )}
              </FlexWrapper>
              <FlexWrapper viewPadding={viewPadding ? viewPadding : '14px 16px 20px'}>{children}</FlexWrapper>
            </ModalWrapper>
          </Overlay>
        )}
      </React.Fragment>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal.js